import React, { Component, Fragment } from 'react';
import { Container } from 'semantic-ui-react';
import { connect } from "react-redux";
import Step1 from './service-available/Step1';
import Step2 from './service-available/Step2';
import Step3 from './service-available/Step3';
import Step4 from './service-available/Step4';
import Step5 from './service-available/Step5';
import Step6 from './service-available/Step6';
import DefaultCheckAvailabilityFooter from '../footer/DefaultCheckAvailabilityFooter';
import NeedHelpFooter from "../footer/NeedHelpFooter";
import ScheduleInstallation from './service-available/ScheduleInstallation';
import WoohooConfirmation from './service-available/WoohooConfirmation';
import GetExcitedConfirmation from './service-available/GetExcitedConfirmation';
import ThankYou from './service-not-available/Step6';
import {shouldProcessAsUnscheduledLead} from '../../util';

class ServiceAvailable extends Component {
  constructor(props) {
      super(props);
      this.state = {
          activeStep: 1,
          animation: "fade left"
      };

      this.changeStep = this.changeStep.bind(this);
  }

  changeStep(step, animation) {
    window.scrollTo(0,0);

    // Handle back button step change when it shouldProcessAsUnscheduledLead
    if ([4, 7].includes(step) && this.props.form && shouldProcessAsUnscheduledLead(this.props.form.unlimitedInternetObj.code)) {
      step = 2;
    }

    this.setState({
      activeStep: step,
      animation: animation
    });
  }

  renderStep() {
    const { activeStep, animation } = this.state;

    switch(activeStep) {
      case 1:
        return <Step1 setServiceAvailable={this.props.setServiceAvailable} changeStep={this.changeStep} animation={animation} />
      case 2:
        return <Step2 changeStep={this.changeStep} animation={animation}/>
      case 3:
        return <Step3 changeStep={this.changeStep} animation={animation}/>
      case 4:
        return <Step4 changeStep={this.changeStep} animation={animation}/>
      case 5:
        return <Step5 changeStep={this.changeStep} animation={animation} />
      case 6:
        return <Step6 changeStep={this.changeStep} animation={animation} />
      case 7:
      return <ScheduleInstallation changeStep={this.changeStep} animation={animation}/>
      case 8:
      return <WoohooConfirmation changeStep={this.changeStep} animation={animation} />
      case 9:
        return <GetExcitedConfirmation changeStep={this.changeStep} animation={animation}/>
      case 10:
        return <ThankYou changeStep={this.changeStep} animation={animation} backButton={false}/>
        default:
    }
  }

  renderFooter() {
    const { activeStep } = this.state;

    switch(activeStep) {
      case 2:
      case 3:
      case 4:
      case 5:
        return <NeedHelpFooter />
      default:
        return <DefaultCheckAvailabilityFooter />
    }
  }

  render() {
    return (
      <Fragment>
        <section className="check-availability space">
          <Container>
            { this.renderStep() }
          </Container>
        </section>
        { this.renderFooter() }
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    form: state.form
  };
};

export default connect(
  mapStateToProps
)(ServiceAvailable);


// WEBPACK FOOTER //
// ./src/components/check-availability/ServiceAvailable.js